export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
